/** The Complete stage action element. */
import { MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Completes a stage of the run's Job; a stage already completed, finalised or closed is left as it is. */
export const COMPLETE_JOB_STAGE_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.CompleteJobStage,
    family: WorkflowFamily.Stage,
    sideEffect: WorkflowSideEffect.TriggerVisible,
    title: 'Complete a stage of the Job',
    icon: 'fa-circle-check',
    fields: [
        {
            bind: 'input.stageId',
            required: true,
            renderer: WorkflowFieldRenderer.Binding,
            metadata: {
                displayName: 'Stage',
                type: MetadataEntityFieldType.Lookup,
                entity: ActivityEntityName.WorkOrder,
            },
        },
        {
            bind: 'input.notes',
            renderer: WorkflowFieldRenderer.MergeText,
            metadata: {
                displayName: 'Notes',
                type: MetadataEntityFieldType.String,
                editor: MetadataEntityFieldEditorType.TextArea,
            },
        },
    ],
    outputs: [
        { path: 'stageId', metadata: { displayName: 'Stage ID', type: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrder } },
        // The stage's tenant status after the step, as a record typed from the stage's own Status field.
        { path: 'status', entityField: { entity: ActivityEntityName.WorkOrder, field: 'status' }, metadata: { displayName: 'Status', type: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrderStatus } },
        // The system status it rolls up to (`SystemWorkOrderStatus`), typed from the stage status's own field.
        { path: 'systemStatus', entityField: { entity: ActivityEntityName.WorkOrderStatus, field: 'systemStatus' }, metadata: { displayName: 'System status', type: MetadataEntityFieldType.Enum } },
        { path: 'alreadyCompleted', metadata: { displayName: 'Already completed', type: MetadataEntityFieldType.Boolean } },
    ],
};
